import { green, orange, red } from '@mui/material/colors';
// follow the RFC-5322 -> https://datatracker.ietf.org/doc/html/rfc5322
export const EMAIL_REGEX_FORMAT = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;
export const DL_REGEX_FORMAT = /[^a-zA-Z0-9]/g;
export const NUMBER_ONLY_FORMAT = /\D/g;
export const ALPHANUMERIC_NO_SPACE_STRICT = /^[A-Za-z0-9]*$/;
export const ALPHANUMERIC_WITH_SPACE_STRICT = /^[A-Za-z0-9\s]+$/;
export const DOMAIN_REGEX_FORMAT = /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/;

export const MOBILE_BREAKPOINT_PX = 768;

export const PERMISSION_NAME = {
    VIEW: 'VIEW',
    FULL_ACCESS: 'FULL_ACCESS',
};

export const FEATURE_LEVEL = {
    CLIENT: 'CLIENT',
    ROOT: 'ROOT',
};

export const DATA_RESTRICTION_CONFIG_TYPE = {
    SUPPORTED_DATA_RESTRICTION: 'SUPPORTED_DATA_RESTRICTION',
    UNSUPPORTED_FEATURE_PERMISSION: 'UNSUPPORTED_FEATURE_PERMISSION',
};

export const FEATURE_NAME = {
    INVENTORY: 'Inventory',
    ACCESS_POINT_RECORDS: 'AccessPointRecords',
    YARD_CHECK: 'YardCheck',
    DIVISION: 'Division',
    ORGANIZATIONS: 'Organizations',
    LOCATIONS: 'Locations',
    AUTHORIZED_LIST_PEOPLE: 'AuthorizedListPeople',
    AUTHORIZED_LIST_ORGANIZATION: 'AuthorizedListOrganization',
    AUTHORIZED_EQUIPMENT: 'AuthorizedEquipment',
    CLIENT_EQUIPMENT: 'ClientEquipment',
    CLIENT_REQUEST: 'ClientRequest',
    USER_AND_PERMISSION: 'UserPermissions',
    APPOINTMENTS: 'Appointments',
    SSO_CONFIGURATION: 'SSOConfiguration',
    MONITORING_OBJECTS: 'MonitoringObjects',
    CLIENT_PERSONNEL: 'ClientPersonnel',
};

export const DATA_TABLE_DEFAULT_PAGE_SIZE = 100;
export const ROLES = {
    ADMIN: 'admin',
    AGENT: 'agent',
    USER: 'user',
    HR: 'hr',
    HQ_SUPPORT: 'hq_support',
    FACILITY_MANAGER: 'facility_manager',
    SALES: 'sales',
    TECH: 'tech',
    ORGANIZATION_ADMIN: 'organization_admin',
    TEAM_LEADER: 'team_leader',
    EXTERNAL_USER: 'external_user',
};

export const USER_STATUS = {
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
};

export const PEOPLE_TITLE_LIST = [
    'Accountant',
    'Cleaner',
    'Cleaning Lady',
    'Customer Service Department',
    'Dispatcher',
    'Dock Operator',
    'Dock Supervisor',
    'Driver',
    'Driver (Owner Operator)',
    'Driver Instructor',
    'Electrician',
    'Equipment Manager',
    'GPS Installer',
    'Guard',
    'Maintenance',
    'Manager',
    'Mechanic',
    'Office Staff',
    'Operations Manager',
    'Owner',
    'Partner',
    'Property Manager',
    'Repair',
    'Safety & Compliance Co-Ordinator',
    'Safety Manager',
    'Secretary',
    'Shop Manager',
    'Shop Mechanic',
    'Shunt Driver',
    'Tech',
    'Vendor',
    'Warehouse Personnel',
    'Washer',
    'Worker',
    'Yard Manager',
];

export const PEOPLE_ID_COUNTRY = [
    'Alabama (AL)',
    'Alaska (AK)',
    'Arizona (AZ)',
    'Arkansas (AR)',
    'California (CA)',
    'Colorado (CO)',
    'Connecticut (CT)',
    'Delaware (DE)',
    'Florida (FL)',
    'Georgia (GA)',
    'Hawaii (HI)',
    'Idaho (ID)',
    'Illinois (IL)',
    'Indiana (IN)',
    'Iowa (IA)',
    'Kansas (KS)',
    'Kentucky (KY)',
    'Louisiana (LA)',
    'Maine (ME)',
    'Maryland (MD)',
    'Massachusetts (MA)',
    'Michigan (MI)',
    'Minnesota (MN)',
    'Mississippi (MS)',
    'Missouri (MO)',
    'Montana (MT)',
    'Nebraska (NE)',
    'Nevada (NV)',
    'New Hampshire (NH)',
    'New Jersey (NJ)',
    'New Mexico (NM)',
    'New York (NY)',
    'North Carolina (NC)',
    'North Dakota (ND)',
    'Ohio (OH)',
    'Oklahoma (OK)',
    'Oregon (OR)',
    'Pennsylvania (PA)',
    'Rhode Island (RI)',
    'South Carolina (SC)',
    'South Dakota (SD)',
    'Tennessee (TN)',
    'Texas (TX)',
    'Utah (UT)',
    'Vermont (VT)',
    'Virginia (VA)',
    'Washington (WA)',
    'West Virginia (WV)',
    'Wisconsin (WI)',
    'Wyoming (WY)',
    'Mexico (MEX)',
    'Canada (CAN)',
];

export const PERIOD_ACCESS_TYPES = {
    ONE_TIME: 'ONE_TIME',
    DATE_PERIOD: 'DATE_PERIOD',
    TIME_PERIOD: 'TIME_PERIOD',
    WEEKDAYS: 'WEEKDAYS',
    PERMANENT: 'PERMANENT',
    NO_LIMIT: 'NO_LIMIT',
};

export const PERIOD_ACCESS_TYPE_NAMES = {
    [PERIOD_ACCESS_TYPES.ONE_TIME]: 'One Time',
    [PERIOD_ACCESS_TYPES.DATE_PERIOD]: 'Date Period',
    [PERIOD_ACCESS_TYPES.TIME_PERIOD]: 'Time Period',
    [PERIOD_ACCESS_TYPES.WEEKDAYS]: 'Weekdays',
    [PERIOD_ACCESS_TYPES.PERMANENT]: 'Ongoing',
};

export const INDUSTRY_OPTIONS = [
    {
        label: 'Automotive',
        value: 'AUTOMOTIVE',
    },
    {
        label: 'Trucking',
        value: 'TRUCKING',
    },
    {
        label: 'Residental',
        value: 'RESIDENTAL',
    },
];

export const RELATION_OPTIONS = [
    {
        label: 'Tenant',
        value: 'TENANT',
    },
    {
        label: 'Third Party Carrier',
        value: 'THIRD_PARTY_CARRIER',
    },
    {
        label: 'Vendor',
        value: 'VENDOR',
    },
];

export const ALERT_TYPES = {
    PRIVILEGED_PEOPLE: 'Privileged People',
    PRIVILEGED_EQUIPMENT: 'Privileged Equipment',
    PRIVILEGED_COMPANY: 'Privileged Company',
    SPECIFIC_REQUESTS_COMPANY: 'Specific Requests Company',
    SPECIFIC_REQUESTS_ORGANIZATION: 'Specific Requests Organization',
    PRIVILEGED_ORGANIZATION: 'Privileged Organization',
    BANNED: 'Banned',
    INFORMATION: 'Information',
    SPECIALIZED_PICKUPS: 'Specialized pickups',
    DEFAULT: 'Default',
};

export const ALERT_TYPE_EQUIPMENT = [
    ALERT_TYPES.DEFAULT.toLowerCase(),
    ALERT_TYPES.BANNED.toLowerCase(),
    ALERT_TYPES.PRIVILEGED_EQUIPMENT.toLowerCase(),
    ALERT_TYPES.INFORMATION.toLowerCase(),
    ALERT_TYPES.SPECIALIZED_PICKUPS.toLowerCase(),
];

export const ROUTE_PATH = {
    SSO_CONFIGURATION: '/sso-configuration',
};

export const APPOINTMENT_STATUS_COLORS = {
    Inactive: red[500],
    Active: orange[500],
    Completed: green[500],
};

export const APPOINTMENT_STATUS = {
    INACTIVE: 'Inactive',
    ACTIVE: 'Active',
    COMPLETED: 'Completed',
};

export const DEFAULT_PAGING = {
    PAGE_NUMBER: 0,
    PAGE_SIZE: 1_000_000,
};

export const FIELD_FILTER_OPERATIONS = [
    '=',
    '<>',
    '>',
    '<',
    '>=',
    '<=',
    'contains',
    'notcontains',
    'startswith',
    'endswith',
    'isblank',
    'isnotblank',
    'between',
    'anyof',
    'noneof',
];

export const INVENTORY_STATUS = {
    GOOD_TO_GO: 'Good To Go',
    IN_SHOP: 'In Shop',
    GROUNDED: 'Grounded',
    IN_LEASE: 'In Lease',
    IN_SALE_TRADE: 'In Sale / Trade',
    ANNUAL_INSPECT: 'Annual Inspect',
    WASH: 'Wash',
    UNAVAILABLE: 'Unavailable',
    BREAKDOWN: 'Breakdown',
    TERMINATED: 'Terminated',
};

export const DATE_TIME_SELECTED_OPTIONS = {
    NO_DATE_SPEC: 'NoDateSpecific',
    SELECTED_DATE: 'SelectedDate',
};

export const INVENTORY_MODE = {
    ON: 'ON',
    OFF: 'OFF',
    LASTA_ONLY: 'LASTA_ONLY',
};

export const INVENTORY_MODE_LABEL = {
    ON: 'On',
    OFF: 'Off',
    LASTA_ONLY: 'Lasta Only',
};

export const CONFIRMATION_MESSAGES = {
    REMOVE_ASSET: 'Are you sure you want to remove this Asset from the Current Inventory?',
    REMOVE_YARD_CHECK: 'Are you sure you want to remove this yard check?',
    REMOVE_CHECKED_ASSET: 'Are you sure you want to remove this asset from the yard check items?',
    REMOVE_IDENTITY_PROVIDER: 'Are you sure you want to remove this Identity Provider?',
    REMOVE_IDENTITY_PROVIDER_WARNING:
        'It will only be removed from the Client Portal. The configuration is still remained in Keycloak and may need manual removal if necessary.',
    DEACTIVATE_INVENTORY: 'Are you sure you want to deactivate inventory for this location? This will delete all inventory items.',
};

export const CONFIRMATION_TITLES = {
    DEACTIVATE_INVENTORY: 'Deactivate Inventory',
};
export const TEMP_FIELD_PREFIX = 'temp_field_';
export const APC_INVENTORY_LOOKUP_FIELDS = {
    'vehicle.unitNumber': 'Unit #',
    'vehicle.licensePlateNumber': 'License Plate #',
    'trailer.trailerNumber': 'Trailer #',
    'trailer.containerNumber': 'Container #',
    'trailer.chassisNumber': 'Chassis #',
    'trailer.dollyNumber': 'Dolly Number',
    'trailer.trailerNumberTwo': 'Trailer #2',
};

export const INVENTOR_CATEGORY = {
    VEHICLE: 'VEHICLE',
    EQUIPMENT: 'EQUIPMENT',
};

export const GATE_DIRECTION = {
    IN: 'IN',
    OUT: 'OUT',
};

export const DYNAMIC_FORM_CAPTION = {
    CARGO: 'Cargo',
    GENERAL: 'General',
    OPTIONS: 'Options',
    SAFETY: 'Safety',
    ADDITIONAL: 'Additional',
    VEHICLE: 'Vehicle',
    COMPANY: 'Company',
    PERSON: 'Person',
    TRAILER: 'Trailer',
};

export const YARD_CHECK_STATUS_LABEL = {
    OPEN: 'Open',
    CHECKING: 'In Progress',
    FINISH: 'Completed',
};

export const YARD_CHECK_STATUS = {
    OPEN: 'OPEN',
    CHECKING: 'CHECKING',
    FINISH: 'FINISH',
};

export const YARD_CHECK_DETAIL_GROUP = {
    REMAINING: 'Items to Check',
    CHECKED: 'Checked Items',
};

export const YARD_CHECK_ITEM_TYPE = {
    MISSING: 'MISSING',
    NEW: 'NEW',
    MATCHED: 'MATCHED',
    UPDATED: 'UPDATED',
};

export const YARD_CHECK_ITEM_TYPE_LABEL = {
    MISSING: 'Missed',
    NEW: 'Added',
    MATCHED: 'Matched',
    UPDATED: 'Updated',
};

export const SESSION_STORAGE_KEY = {
    LOCATION_ID: 'locationId',
};

export const INVENTORY_ACCESS_TYPE = {
    CAR: 'Car',
    TRUCKS: 'Trucks',
    TRAILER: 'Trailer',
    CONTAINER: 'Container',
    DOLLY: 'Dolly',
    CHASSIS: 'Chassis',
    OTHER_EQUIPMENT: 'Other_equipment',
    OTHER_VEHICLES: 'Other_vehicles',
};

export const SUMMARY_ACTION = {
    UPDATE: 'UPDATE_TO_INVENTORY',
    ADD: 'ADD_TO_INVENTORY',
    REMOVED: 'REMOVE_FROM_INVENTORY',
    SKIP: 'IGNORE',
};

export const SUMMARY_ACTION_TEXT = {
    [SUMMARY_ACTION.UPDATE]: 'Update',
    [SUMMARY_ACTION.ADD]: 'Add',
    [SUMMARY_ACTION.REMOVED]: 'Remove',
    [SUMMARY_ACTION.SKIP]: 'Ignore',
};

export const GATE_DIRECTION_MAP = {
    GATE_IN: 'IN',
    GATE_OUT: 'OUT',
};

export const FILE_FORMAT = {
    PDF: 'pdf',
    XLS: 'xls',
    CSV: 'csv',
    XLSX: 'xlsx',
};

export const AccessControlType = {
    RESTRICTED: 'RESTRICTED',
    OPEN_ACCESS: 'OPEN_ACCESS',
};

export const SIDE_PANEL_FILTER_METHOD = {
    OR: 'OR',
    AND: 'AND',
};

// With new UI we will fix the height of table.
export const TABLE_VIEWPORT_OFFSET = {
    ACCESS_POINT_RECORDS: 182,
    INVENTORY: 182,
    APPOINTMENT: 182,
    PEOPLE: 175,
    ORG: 175,
    AUTH_ORG: 175,
    AUTH_EQUIPMENT: 175,
    EQUIPMENT: 182,
    YARD_CHECK: 140,
    MANAGEMENT: 140,
    PERSONNEL: 140,
    SSO_CONFIGURATION: 140,
    MONITORING_OBJECT: 182,
};

export const TRAILER_NUMBER_FIELDS = ['trailer_trailerNumber', 'trailer_trailerNumberTwo'];

export const EQUIPMENT_MAPPING_LABEL = {
    'trailer.trailerNumber': 'Trailer #',
    'trailer.trailerNumberTwo': 'Trailer #',
    'trailer.containerNumber': 'Container #',
    'trailer.chassisNumber': 'Chassis #',
    'trailer.dollyNumber': 'Dolly #',
    'trailer.equipmentNumber': 'Equipment #',
    'vehicle.unitNumber': 'Unit #',
    'vehicle.licensePlateNumber': 'License Plate #',
};

export const EQUIPMENT_CATEGORY_FILTERS = {
    'vehicle.unitNumber': ['Truck'],
    'vehicle.licensePlateNumber': ['Straight truck', 'Pickup truck', 'Personal', 'Van', 'Bus', 'Utility', 'Emergency'],
    'trailer.trailerNumber': ['Trailer'],
    'trailer.trailerNumberTwo': ['Trailer'],
    'trailer.containerNumber': ['Container'],
    'trailer.chassisNumber': ['Chassis'],
    'trailer.dollyNumber': ['Dolly'],
};

export const EQUIPMENT_LOOKUP_FILTERS = ['vehicle.unitNumber', 'vehicle.licensePlateNumber'];

export const INVENTORY_VIEW_MODE = {
    SHORT: 'short',
    FULL: 'full',
};

export const USER_HEADER = {
    ADMIN: 'Lasta',
    EXTERNAL_USER: 'Birdseye Portal',
};
